import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeacherProfile } from "../../../redux/Actions/teacherProfileActions";
import TeacherApplicationForm from "./TeacherApplicationForm";

const isApproved = profile => profile?.confirmedFromAdmin === true
  && String(profile?.status || "").trim().toLowerCase() === "approved";

export default function TeacherApprovalGate({ children }) {
  const dispatch = useDispatch();
  const profile = useSelector(state => state.teacherProfile.profile);
  const roles = useSelector(state => state.auth.user.roleNames || []);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadProfile = async () => {
    setLoading(true);
    const result = await dispatch(fetchTeacherProfile());
    setError(result?.success ? "" : String(result?.message || "Could not load teacher approval status."));
    setLoading(false);
  };

  const elevatedTeacherRole = roles.some(role => ["TEACHER_MANAGER", "ADMIN", "ADMIN_DEVELOPER"].includes(String(role).toUpperCase()));
  const isTeacher = roles.some(role => String(role).toUpperCase() === "TEACHER");
  useEffect(() => { if (elevatedTeacherRole) setLoading(false); else loadProfile(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (elevatedTeacherRole || !isTeacher) return children;

  if (loading) return <Container sx={{ py: 10, display: "grid", placeItems: "center" }}><CircularProgress /></Container>;
  if (error || !profile) return <Container maxWidth="sm" sx={{ py: 8 }}><Alert severity="error" action={<Button color="inherit" size="small" onClick={loadProfile}>Retry</Button>}>{error || "Teacher profile could not be loaded."}</Alert></Container>;
  if (!isApproved(profile)) return <Container maxWidth="sm" sx={{ py: 6 }}><Box sx={{ mb: 2 }}><Alert severity="warning">Your teacher dashboard is available after your application is approved. Submit your CV and certificate for review.</Alert></Box><TeacherApplicationForm pageMode /></Container>;
  return children;
}

export { isApproved as isTeacherApproved };
